import { useState } from "react";
import { THEMES } from "./theme";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const AVATAR_COLORS = ["#5b6ef8","#22d3a0","#a855f7","#ef4444","#f5a623","#14b8a6","#f97316","#06b6d4","#ec4899","#84cc16"];

export default function UserProfile({ T, user, onClose, onSaved }) {
  const [theme, setTheme]   = useState(user.theme_id||"dark_indigo");
  const [color, setColor]   = useState(user.avatar_color||"#5b6ef8");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved]   = useState(false);
  const [pwd, setPwd]       = useState({current:"",nouveau:"",confirm:""});
  const [pwdErr, setPwdErr] = useState("");
  const [tab, setTab]       = useState("apparence");

  const save = async () => {
    setSaving(true);
    const res = await fetch(`${BASE}/users/${user.id}/preferences`,{
      method:"PATCH", headers:h(),
      body:JSON.stringify({theme_id:theme, avatar_color:color})
    }).then(r=>r.json());
    // Sauvegarder dans localStorage
    const updatedUser = {...user, theme_id:theme, avatar_color:color};
    localStorage.setItem("nexo_user", JSON.stringify(updatedUser));
    setSaving(false); setSaved(true);
    setTimeout(()=>{setSaved(false); onSaved&&onSaved(updatedUser);},1500);
  };

  const changePwd = async () => {
    if (pwd.nouveau !== pwd.confirm) { setPwdErr("Les mots de passe ne correspondent pas"); return; }
    if (pwd.nouveau.length < 6) { setPwdErr("Minimum 6 caractères"); return; }
    setSaving(true);
    const res = await fetch(`${BASE}/users/${user.id}/password`,{
      method:"PATCH", headers:h(),
      body:JSON.stringify({password:pwd.nouveau})
    }).then(r=>r.json());
    setSaving(false);
    if (res.error) { setPwdErr(res.error); return; }
    setPwd({current:"",nouveau:"",confirm:""});
    setPwdErr(""); setSaved(true);
    setTimeout(()=>setSaved(false),2000);
  };

  const initials = `${user.prenom?.[0]||""}${user.nom?.[0]||""}`.toUpperCase();

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.35)",backdropFilter:"blur(4px)",zIndex:1000,display:"flex",alignItems:"flex-start",justifyContent:"flex-end",padding:"60px 16px 0 0"}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:340,maxHeight:"80vh",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,0.2)",animation:"dropIn 0.2s cubic-bezier(0.34,1.56,0.64,1)"}}>
        <style>{`@keyframes dropIn{from{opacity:0;transform:translateY(-10px) scale(0.97)}to{opacity:1;transform:translateY(0) scale(1)}}`}</style>

        {/* Header */}
        <div style={{padding:"20px 24px 16px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <div style={{width:52,height:52,borderRadius:"50%",background:`${color}22`,border:`3px solid ${color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color}}>
              {initials}
            </div>
            <div>
              <div style={{fontSize:17,fontWeight:800,color:T.text}}>{user.prenom} {user.nom}</div>
              <div style={{fontSize:12,color:T.muted,marginTop:2}}>{user.role} · {user.email}</div>
            </div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>

        {/* Tabs */}
        <div style={{display:"flex",borderBottom:`1px solid ${T.border}`,flexShrink:0}}>
          {[["apparence","🎨 Apparence"],["securite","🔐 Sécurité"],["infos","👤 Infos"]].map(([k,l])=>(
            <button key={k} onClick={()=>setTab(k)}
              style={{flex:1,padding:"11px",background:tab===k?T.accentDim:"transparent",border:"none",borderBottom:tab===k?`2px solid ${T.accent}`:"2px solid transparent",color:tab===k?T.accent:T.muted,fontSize:13,fontWeight:tab===k?700:500,cursor:"pointer"}}>
              {l}
            </button>
          ))}
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

          {/* APPARENCE */}
          {tab==="apparence"&&(
            <div style={{display:"flex",flexDirection:"column",gap:20}}>

              {/* Couleur avatar */}
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>🎨 Couleur de votre avatar</div>
                <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  {AVATAR_COLORS.map(c=>(
                    <div key={c} onClick={()=>setColor(c)} style={{cursor:"pointer",position:"relative"}}>
                      <div style={{width:40,height:40,borderRadius:"50%",background:c,border:`3px solid ${color===c?"#fff":"transparent"}`,boxShadow:color===c?`0 0 0 3px ${c}`:"none",transition:"all 0.2s"}}/>
                      {color===c&&<div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:800,color:"#fff"}}>✓</div>}
                    </div>
                  ))}
                </div>
                <div style={{marginTop:12,width:60,height:60,borderRadius:"50%",background:`${color}22`,border:`3px solid ${color}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,fontWeight:800,color}}>
                  {initials}
                </div>
              </div>

              {/* Thème */}
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>🌓 Thème de l'interface</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  {Object.entries(THEMES).map(([id,th])=>(
                    <div key={id} onClick={()=>setTheme(id)}
                      style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",borderRadius:11,border:`1.5px solid ${theme===id?T.accent:T.border}`,background:theme===id?T.accentDim:"transparent",cursor:"pointer",transition:"all 0.15s"}}>
                      {/* Preview couleurs */}
                      <div style={{display:"flex",gap:4,flexShrink:0}}>
                        <div style={{width:20,height:20,borderRadius:5,background:th.bg,border:`1px solid ${th.border}`}}/>
                        <div style={{width:20,height:20,borderRadius:5,background:th.card,border:`1px solid ${th.border}`}}/>
                        <div style={{width:20,height:20,borderRadius:5,background:th.accent}}/>
                      </div>
                      <div style={{flex:1,fontSize:13,fontWeight:theme===id?700:500,color:theme===id?T.accent:T.text}}>{th.name}</div>
                      {theme===id&&<span style={{color:T.accent,fontWeight:800}}>✓</span>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* SÉCURITÉ */}
          {tab==="securite"&&(
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>🔐 Changer le mot de passe</div>
              {pwdErr&&<div style={{background:T.dangerDim,border:`1px solid ${T.danger}40`,borderRadius:9,padding:"10px 13px",fontSize:13,color:T.danger}}>⚠ {pwdErr}</div>}
              {[["nouveau","Nouveau mot de passe"],["confirm","Confirmer le mot de passe"]].map(([k,l])=>(
                <div key={k}>
                  <label style={{fontSize:11,fontWeight:700,color:T.muted,display:"block",marginBottom:5,textTransform:"uppercase",letterSpacing:"0.5px"}}>{l}</label>
                  <input type="password" value={pwd[k]} onChange={e=>setPwd(p=>({...p,[k]:e.target.value}))}
                    style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 13px",color:T.text,fontSize:14,outline:"none",width:"100%"}}/>
                </div>
              ))}
              <button onClick={changePwd} disabled={saving||!pwd.nouveau||!pwd.confirm}
                style={{padding:"11px",borderRadius:10,background:pwd.nouveau&&pwd.confirm?T.accent:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer"}}>
                {saving?"Modification...":"🔐 Modifier le mot de passe"}
              </button>
              <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:11,padding:14,fontSize:12,color:T.muted}}>
                <div style={{fontWeight:700,marginBottom:6}}>Conseils sécurité :</div>
                <div>· Minimum 8 caractères</div>
                <div>· Mélanger majuscules, minuscules, chiffres</div>
                <div>· Ne pas réutiliser un ancien mot de passe</div>
              </div>
            </div>
          )}

          {/* INFOS */}
          {tab==="infos"&&(
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>👤 Informations du compte</div>
              {[["Prénom",user.prenom],["Nom",user.nom],["Email",user.email],["Rôle",user.role],["ID",user.id?.slice(-8).toUpperCase()]].map(([l,v])=>(
                <div key={l} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:10,padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:12,color:T.muted,fontWeight:600}}>{l}</span>
                  <span style={{fontSize:13,fontWeight:700,color:T.text,fontFamily:l==="ID"?"monospace":"inherit"}}>{v||"—"}</span>
                </div>
              ))}
              <div style={{background:T.accentDim,border:`1px solid ${T.accent}30`,borderRadius:10,padding:"11px 14px",fontSize:12,color:T.muted}}>
                💡 Pour modifier vos informations, contactez un administrateur
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        {tab==="apparence"&&(
          <div style={{padding:"14px 24px",borderTop:`1px solid ${T.border}`,flexShrink:0}}>
            <button onClick={save} disabled={saving}
              style={{width:"100%",padding:"12px",borderRadius:11,background:saved?T.success:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:"pointer",transition:"all 0.3s"}}>
              {saving?"Enregistrement...":saved?"✅ Thème appliqué !":"💾 Appliquer le thème"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
